function cov_unyg214vc() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Money.tsx";
  var hash = "54a0d18225c930de23f74fab7fd3626da8548293";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Money.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 45
        },
        end: {
          line: 5,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "54a0d18225c930de23f74fab7fd3626da8548293"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_unyg214vc = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_unyg214vc();
var Icon = (cov_unyg214vc().s[0]++, {
  name: 'money',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 6.25C10.6236 6.25 9.5305 7.08682 8.83862 8.12464C8.14091 9.1712 7.75 10.545 7.75 12C7.75 13.455 8.14091 14.8288 8.83862 15.8754C9.5305 16.9132 10.6236 17.75 12 17.75C13.3764 17.75 14.4695 16.9132 15.1614 15.8754C15.8591 14.8288 16.25 13.455 16.25 12C16.25 10.545 15.8591 9.1712 15.1614 8.12464C14.4695 7.08682 13.3764 6.25 12 6.25ZM10.25 12C10.25 10.9697 10.5307 10.0935 10.9187 9.51139C11.3126 8.92053 11.7196 8.75 12 8.75C12.2804 8.75 12.6874 8.92053 13.0813 9.51139C13.4693 10.0935 13.75 10.9697 13.75 12C13.75 13.0303 13.4693 13.9065 13.0813 14.4886C12.6874 15.0795 12.2804 15.25 12 15.25C11.7196 15.25 11.3126 15.0795 10.9187 14.4886C10.5307 13.9065 10.25 13.0303 10.25 12Z\" fill=\"currentColor\"/>\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0 19.25C0 20.2165 0.783502 21 1.75 21H22.25C23.2165 21 24 20.2165 24 19.25V4.75C24 3.7835 23.2165 3 22.25 3H1.75C0.783502 3 0 3.7835 0 4.75V19.25ZM5.95852 5.5C5.9858 5.6626 6 5.82964 6 6C6 7.65685 4.65685 9 3 9C2.82964 9 2.6626 8.9858 2.5 8.95852V15.0415C2.6626 15.0142 2.82964 15 3 15C4.65685 15 6 16.3431 6 18C6 18.1704 5.9858 18.3374 5.95852 18.5H18.0415C18.0142 18.3374 18 18.1704 18 18C18 16.3431 19.3431 15 21 15C21.1704 15 21.3374 15.0142 21.5 15.0415V8.95852C21.3374 8.9858 21.1704 9 21 9C19.3431 9 18 7.65685 18 6C18 5.82964 18.0142 5.6626 18.0415 5.5H5.95852Z\" fill=\"currentColor\"/>"
});
export default Icon;